// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610140629/js/" + chunkId + "." + {"44":"92c09707","225":"f5438ac4","481":"14803f95","486":"67d36fa8","770":"efa64786"}[chunkId] + ".0.29385425243577523.chunk.js";
};